import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from "react-redux";

import ButtonIconV2 from '../common/ButtonIconV2';
import IconEdit from '../svg/IconEdit';

import {
  setTouchEditor,
  setSelectedItems
} from "../../../actions/index";

function ConnectedButtonEditor({ label, touchEditor, style }) {
  const dispatch = useDispatch();
  const toggleEditor = () => {
    const state = !touchEditor;
    dispatch(setTouchEditor(state));
    if (!state) {
      dispatch(setSelectedItems([]));
    }
  }
  return <ButtonIconV2
    className={`${touchEditor ? `active` : ''}`}
    style={style}
    icon={<IconEdit color={ touchEditor ? Config.BRAND_PRIMARY : '#8C8C8C' } />}
    label={touchEditor ? 'Close' : label}
    onClick={toggleEditor}
  />
}

ConnectedButtonEditor.propTypes = {
  label: PropTypes.string.isRequired,
  touchEditor: PropTypes.bool.isRequired,
  style: PropTypes.object
}

const ButtonEditor = connect(
  state => ({
    touchEditor: state.touchEditor,
  })
)(ConnectedButtonEditor);

export default ButtonEditor;
